export default __webpack_public_path__ + "static/diagram-docker-swarm-3e580ff5408d5754ab07a760146e7e10.svg";